import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { Button, IconSvg, Modal, Text } from '@/lib/v2/components';
import { ActionConfirmIcon } from '@/lib/v2/icons/general';

import { atomToggleConfirmActionModal } from '@/modules/CampaignsModule/atoms/actionsAtom';

const MODAL_CONFIRM_ACTION = 'CAMPAIGN_ACTIONS_MAIN.MODAL_CONFIRM_ACTION';

interface IConfirmActionProps {
  onConfirm: () => void;
  loading?: boolean;
}

const ConfirmAction = ({ onConfirm, loading }: IConfirmActionProps) => {
  const { t } = useTranslation();

  const [toggleConfirmActionModal, setToggleConfirmActionModal] = useAtom(
    atomToggleConfirmActionModal
  );

  const handleConfirmAction = () => onConfirm?.();
  const handleCancel = () => setToggleConfirmActionModal(false);

  return (
    <Modal open={toggleConfirmActionModal} showCloseButton={false}>
      <div className="flex flex-col justify-center">
        <div className="flex w-full flex-col">
          <Text fontWeight="medium" variant="sub-headline">
            {t(`${MODAL_CONFIRM_ACTION}.title`)}
          </Text>
          <hr className="my-4 divide-y" />
        </div>
        <div className="mx-auto flex flex-col justify-center align-middle">
          <IconSvg
            className="mx-auto my-6"
            height="164px"
            svgComponent={<ActionConfirmIcon />}
            width="164px"
          />
          <Text alignment="center" as="p" variant="sub-headline">
            {t(`${MODAL_CONFIRM_ACTION}.detail`)}
          </Text>
          <Text alignment="center" as="p" className="px-6" variant="sub-headline">
            {t(`${MODAL_CONFIRM_ACTION}.description`)}
          </Text>
        </div>
        <div className="mt-9 flex w-full justify-center gap-3">
          <Button outline id="modal-confirm__cancel" onClick={handleCancel}>
            {t(`${MODAL_CONFIRM_ACTION}.cancel`)}
          </Button>
          <Button id="modal-confirm__action" isLoading={loading} onClick={handleConfirmAction}>
            {t(`${MODAL_CONFIRM_ACTION}.confirm`)}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmAction;
